import { RestTrack, TracksReloadJobState } from '@/types'
import axios from 'axios'
import host from '../../utils/host'

class TrackRest {
  private host: string = host

  public get (token: string | null, id: number): Promise<RestTrack[]> {
    return axios.get(`${this.host}/api/campaigns/${id}/tracks`, token ? {
      headers: {
        Authorization: token
      }
    } : {}).then((res) => res.data)
  }

  public reload (token: string|null, id: number): Promise<void> {
    return axios.post(`${host}/api/campaigns/${id}/tracks/jobs/reload`, {}, token ? {
      headers: {
        Authorization: token
      }
    } : {}).then((res) => res.data)
  }

  async getReloadJobState (token: string|null, id: number): Promise<TracksReloadJobState|null> {
    const resp = await axios.get(`${host}/api/campaigns/${id}/jobs/load_campaign_tracks/last`, token ? {
      headers: {
        Authorization: token
      }
    } : {})

    return resp.data
  }
}

export default new TrackRest()
